import Vue from 'vue';
import Vuex from 'vuex';
import storeRuntime from './store-runtime';
import storeStorage from './store-storage';
import applicationStore from './store/application';
import msalStore from './store/msal';
import printStore from './store/print';
import brkStore from './store/brk';
import dashboardStore from './store/nedGlobe/dashboard';
import usage from './store/usage';


Vue.use(Vuex);

//export default
const store = new Vuex.Store({
    plugins: [
        storeStorage
    ],

    modules: { runtime: storeRuntime, },

    state: {
        ...applicationStore.state,
        ...printStore.state,
        ...msalStore.state,
        ...brkStore.state,
        ...dashboardStore.state,
        ...usage.state,
        portal: { organizationName: null },
        userInfo: {
            userID: -1,
            organizationId: -1,
            licenses: {},
            isAdmin: false,
            isFeedbackEditor: false,
            isSuper: false,
            userName: '',
            organizationLanguage: '',
            locale: '',
            isAuthorized: false,
            isAuthenticated: false,
            // Task 19224: Rekening houden met kolom Personal bij het tonen van metingen
            // Session Id is a random generated number of 10 digits.
            sessionId: '',
        },
        unknownUserName: 'Onbekende gebruiker',
        map: {},
        // loaded layers (from nedglobeMap mixin)
        availableLayers: [],
        mobileUserData: {},
        feedbackGroups: {},
        calculatedDPI: null,
        mapLayersLoaded: false,
        sidebarLegendShow: false,
        imageViewerShow: {},
        informationOverviewTabToggle: null,
        informationDetailSidebar: [],
        informationDataLoadingCompleted: false,
        attributeFilters: [],
        hasPersonalFilter: false,
        // Indicates data loading for informationOverviewTab
        informationDataLoadingStarted: false,
        // Shows the refresch button of informationOverviewTab
        informationTableRefreshareaUpdatebuttondisplay: false,
        feedbackSidebarShow: false,
        isMobile: false,
        isIe: null,
        isFullScreen: false,
        stopTracking: false,
        featureSelected: null,
        // Feedback selection action
        feedbackData: {},
        feedbackLocationType: null,
        feedbackFilterData: {},
        // Feedback edit & delete
        feedbackEdit: {},
        feedbackDelete: {},
        // Feedback load or refresh theme action after feedback add/modify
        feedbackLoadOrRefresh: null,
        // Feedback state
        stateEditingFeedback: false,
        stateDigiFeedback: false,
        // there are feedback requests stored offline
        hasOfflineRequests: false,
        loadTheme: {},
        loadedThemes: [],
        loadedFeedbacks: [],
        loadThemeOptions: {},
        /*Map events*/
        mapOnMoveEnd: false,
        mapOnClick: false,
        mapOnDoubleClick: false,
        mapOnMove: false,
        mapOnZoom: false,
        // Contains al features of all themelayers of a theme
        themeLayersFeatures: [],
        contextMenu: null,
        hasFilters: false,
        undoFilterTheme: null,
        // Refcodes
        refCodes: {},
        // Controls the visibilitye of the Tabhold component
        showTabhold: false,
        selectionClear: false,
        tabholdEndInteraction: false,
        // Commands tabhold to clear selection. Call this event from outside tabhold
        clearTabholdSelection: false,
        //Information table
        loadMoreFeatures: {},
        /* Information table refresharea */
        informationTableRefresh: {},
        informationTableUpdatebuttondisplay: false,
        informationTableDisplayRefreshArea: true,
        informationTableInactiveRefreshArea: false,
        /* Webtheme */
        webTheme: {},
        webfeedbackLocation: [],
        webfeedbackPanelsClose: false,
        webfeedbackCanCreateResolution: null,
        webfeedbackFeatures: {},
        webfeedbackInformation: {},
        webfeedbackAlertClosed: false,
        /* Alerts */
        showAlert: {},
        hideAlert: false,
        tempHideAlert: false,
        /* Gps position  */
        gpsPosition: null,
        gpsIcon: null,
        /* Feedback */
        allFeedbacks: [],
        showFeedbacks: null,
        showPopup: {},
        showFeedbackPanel: null,
        openFeedback: null,
        /* Feedback digitize */
        resetDigitize: null,
        abortDigitize: false,
        updateFeedbackGeometryType: null,
        undoLastPoint: false,
        updateNumPoints: 0,
        closeFeedbackModus: null,
        finishFeedback: null,
        /* Clusters */
        clusterLayerDict: {},
        /* Map search */
        clearSearchMarkerLayer: null,
        addSearchMarkerLayer: null,
        setAddressPoint: null,
        /* Mobile menu */
        mobileMenuShow: false,
        mobileFilterTabhow: false,
        layersPanelShow: false,
        /* Feedback + Measure menu in toolbar */
        setMeasureMenu: null,
        setFeedbackMenu: null,
        setMeasureWeb: null,
        /* Toolbar popup menu */
        showMenuLayersFilters: false,
        /* Rmote commands */
        remoteToMeasurement: false,
        remoteToFeedback: false,
        showSmallDeviceMenu: {},
        /*Forces to runtimeStateRestored even do no baselayer presents*/
        noBaselayerForeceReload: false,
        // UrlConnections
        urlConnections: []
    },

    mutations: {
        ...applicationStore.mutations,
        ...msalStore.mutations,
        ...printStore.mutations,
        ...brkStore.mutations,
        ...dashboardStore.mutations,
        ...usage.mutations,
        PORTAL_SET_ORGANIZATIONNAME(state, organizationName) {
            state.portal.organizationName = organizationName;
        },

        MAP_INITIALIZE(state, data) {
            state.map = data;
        },

        SET_USERINFO(state, userInfo) {
            state.userInfo = userInfo;
        },

        SET_UNKNOWNUSERNAME(state, unknownUserName) {
            state.unknownUserName = unknownUserName;
        },

        ADD_AVAILABLE_LAYERS(state, data) {
            state.availableLayers.push(data);
        },

        REMOVE_AVAILABLE_LAYERS(state, index) {
            state.availableLayers.splice(index, 1);
        },

        MOBILEUSER_DATA(state, data) {
            state.mobileUserData = data;
        },

        IMAGE_VIEWER(state, data) {
            state.imageViewerShow = data;
        },

        MAPLAYERS_LOADED(state, value) {
            state.mapLayersLoaded = value;
        },

        SIDEBAR_LEGEND(state, show) {
            state.sidebarLegendShow = show;
        },
        /****** Information Tab ******/
        INFORMATION_OVERVIEW_TAB(state, value) {
            state.informationOverviewTabToggle = value;
        },

        INFORMATION_DETAIL_SIDEBAR(state, data) {
            state.informationDetailSidebar = data;
        },

        INFORMATION_DATA_LOADING_COMPLETED(state, value) {
            state.informationDataLoadingCompleted = value;
        },

        INFORMATION_DATA_LOADING_STARTED(state, value) {
            state.informationDataLoadingStarted = value;
        },

        INFORMATION_TABLE_REFRESHAREA_UPDATEBUTTONDISPLAY(state, value) {
            state.informationTableRefreshareaUpdatebuttondisplay = value;
        },

        FEEDBACK_SIDEBAR(state, show) {
            state.feedbackSidebarShow = show;
        },

        FEATURE_SELECTED(state, feature) {
            state.featureSelected = feature;
        },

        ISMOBILE_STATE(state, value) {
            state.isMobile = value;
        },

        ISIE_STATE(state, value) {
            state.isIe = value;
        },

        ISFULLSCREEN_STATE(state, value) {
            state.isFullScreen = value;
        },

        STOP_TRACKING(state, value) {
            state.stopTracking = value;
        },

        THEMELAYERS_FEATURES(state, data) {
            state.themeLayersFeatures = data;
        },

        CONTEXT_MENU(state, data) {
            state.contextMenu = data;
        },

        /****** Feedback state ******/
        STATE_EDITING_FEEDBACK(state, data) {
            state.stateEditingFeedback = data;
        },

        STATE_DIGI_FEEDBACK(state, data) {
            state.stateDigiFeedback = data;
        },

        FILTERS_ATTRIBUTE_ADD(state, data) {
            state.attributeFilters = data;
        },

        FILTER_PERSONAL_ADD(state, data) {
            state.hasPersonalFilter = data;
        },

        /****** Mobile/Web loaded themes ******/
        LOADED_THEMES_ADD(state, data) {
            state.loadedThemes.push(data);
        },

        LOADED_THEMES_UPDATE(state, { index, data }) {
            Vue.set(state.loadedThemes, index, data);
        },

        REMOVED_THEME(state, data) {
            state.loadThemeOptions = data;
        },

        LOAD_THEME_OPTIONS(state, data) {
            state.loadThemeOptions = data;
        },

        LOAD_THEME(state, data) {
            state.loadTheme = data;
        },

        /****** Mobile/Web loaded feedbacks ******/
        LOADED_FEEDBACKS_ADD(state, data) {
            state.loadedFeedbacks.push(data);
        },

        LOADED_FEEDBACKS_UPDATE(state, { index, data }) {
            Vue.set(state.loadedFeedbacks, index, data);
        },

        /****** Mobile/Web feedback ******/
        FEEDBACK_DATA_MUTATION(state, data) {
            state.feedbackData = data;
        },

        FEEDBACK_LOCATION_TYPE_MUTATION(state, data) {
            state.feedbackLocationType = data;
        },

        FEEDBACK_LOAD_OR_REFRESH(state, data) {
            state.feedbackLoadOrRefresh = data;
        },

        FEEDBACK_GROUPS_MUTATION(state, data) {
            state.feedbackGroups = data;
        },

        REMOVED_FEEDBACK(state, data) {
            state.feedbackFilterData = data;
        },

        HASOFFLINEREQUESTS_STATE(state, value) {
            state.hasOfflineRequests = value;
        },

        HASFILTERS_STATE(state, value) {
            state.hasFilters = value;
        },

        UNDO_FILTERS(state, value) {
            state.undoFilterTheme = value;
        },

        FEEDBACK_EDIT(state, data) {
            state.feedbackEdit = data;
        },

        FEEDBACK_DELETE(state, data) {
            state.feedbackDelete = data;
        },

        WEBFEEDBACK_LOCATION_MUTATION(state, data) {
            state.webfeedbackLocation = data;
        },

        WEBFEEDBACK_PANELS_CLOSE(state, value) {
            state.webfeedbackPanelsClose = value;
        },

        WEBFEEDBACK_CAN_CREATE(state, value) {
            state.webfeedbackCanCreateResolution = value;
        },

        WEBFEEDBACK_FEATURES_MUTATION(state, data) {
            state.webfeedbackFeatures = data;
        },

        WEBFEEDBACK_INFORMATION_MUTATION(state, data) {
            state.webfeedbackInformation = data;
        },

        WEBFEEDBACK_ALERT_CLOSED(state, data) {
            state.webfeedbackAlertClosed = data;
        },

        /****** Mobile/Web global ******/
        CALCULATED_DPI(state, data) {
            state.calculatedDPI = data;
        },

        /****** Map events ******/
        MAP_MOVEEND(state, value) {
            state.mapOnMoveEnd = true;
        },

        MAP_CLICKED(state, value) {
            state.mapOnClick = value;
        },

        MAP_DOUBLE_CLICKED(state, value) {
            state.mapOnDoubleClick = value;
        },

        MAP_MOVED(state, show) {
            state.mapOnMove = show;
        },

        MAP_ZOOMED(state, show) {
            state.mapOnZoom = show ? show : !state.mapOnZoom;
        },
        /****** Tabhold ******/
        SHOW_TABHOLD(state, show) {
            state.showTabhold = show;
        },

        TABHOLD_END_INTERACTION(state, value) {
            state.tabholdEndInteraction = value;
        },

        SELECTION_CLEAR(state, value) {
            state.selectionClear = value ? value : !state.selectionClear;
        },

        CLEAR_TABHOLD_SELECTION(state, value) {
            state.clearTabholdSelection = value;
        },
        /****** Information table ******/
        LOAD_MORE_FEATURES(state, data) {
            state.loadMoreFeatures = data;
        },
        /****** Information table refresharea ******/
        INFORMATION_TABLE_REFRESH(state, data) {
            state.informationTableRefresh = data;
        },
        INFORMATION_TABLE_UPDATE_BUTTON_DISPLAY(state, value) {
            state.informationTableUpdatebuttondisplay = value;
        },
        INFORMATION_TABLE_DISPLAY_REFRESHAREA(state, value) {
            state.informationTableDisplayRefreshArea = value;
        },
        INFORMATION_TABLE_INACTIVE_REFRESHAREA(state, value) {
            state.informationTableInactiveRefreshArea = value;
        },

        /* Webtheme */
        WEB_THEME(state, data) {
            state.webTheme = data;
        },

        /****** Alerts ******/
        ALERT_SHOW(state, data) {
            state.showAlert = data;
        },

        ALERT_HIDE(state, value) {
            state.hideAlert = value;
        },

        ALERT_HIDE_TEMP(state, value) {
            state.tempHideAlert = value;
        },

        /* Gps position */
        GPS_POSITION(state, value) {
            state.gpsPosition = value;
        },

        CHANGE_GPS_ICON(state, value) {
            state.gpsIcon = value;
        },

        /****** Feedback ******/
        ALL_FEEDBACKS(state, data) {
            state.allFeedbacks = data;
        },

        SHOW_FEEDBACKS_DIALOG(state, data) {
            state.showFeedbacks = data;
        },

        CLOSE_FEEDBACK_MODUS(state, value) {
            state.closeFeedbackModus = value;
        },

        POPUP_SHOW(state, data) {
            state.showPopup = data;
        },

        SHOW_FEEDBACK_PANEL(state, value) {
            state.showFeedbackPanel = value;
        },

        FINISH_FEEDBACK(state, value) {
            state.finishFeedback = value;
        },

        OPEN_FEEDBACK(state, data) {
            state.openFeedback = data;
        },

        /* Feedback digitize */
        RESET_DIGITIZE(state, value) {
            state.resetDigitize = value;
        },

        ABORT_DIGITIZE(state, value) {
            state.abortDigitize = value;
        },

        UPDATE_FEEDBACK_GEOMETRY_TYPE(state, value) {
            state.updateFeedbackGeometryType = value;
        },

        UNDO_LAST_POINT(state, value) {
            state.undoLastPoint = value;
        },

        REMOVE_FEATURES_AND_INTERACTIONS(state, value) {
            state.removeFeaturesAndInteractions = value;
        },

        UPDATE_NUM_POINTS(state, value) {
            state.updateNumPoints = value;
        },

        /****** Clusters ******/
        CLUSTER_ADD(state, data) {
            state.clusterLayerDict[data.id] = data.values;
        },

        CLUSTER_DELETE(state, data) {
            delete state.clusterLayerDict[data.id];
        },

        /****** RefCodes ******/
        SET_REFCODES(state, data) {
            state.refCodes[data.key] = data.values;
        },

        /****** Map search ******/
        CLEAR_SEARCH_MARKER_LAYER(state, value) {
            state.clearSearchMarkerLayer = value;
        },

        ADD_SEARCH_MARKER_LAYER(state, value) {
            state.addSearchMarkerLayer = value;
        },

        SET_ADDRESS_POINT(state, value) {
            state.setAddressPoint = value;
        },

        /****** Mobile menu ******/
        MOBILE_MENU(state, value) {
            state.mobileMenuShow = value;
        },

        MOBILE_FILTERTAB(state, value) {
            state.mobileFilterTabhow = value;
        },

        LAYERS_PANEL(state, value) {
            state.layersPanelShow = value;
        },

        /****** Feedback + Measure menu in toolbar ******/
        SET_MEASURE_MENU(state, data) {
            state.setMeasureMenu = data;
        },

        SET_FEEDBACK_MENU(state, data) {
            state.setFeedbackMenu = data;
        },

        SET_MEASURE_WEB(state, data) {
            state.setMeasureWeb = data;
        },

        /****** Toolbar popup menu ******/
        SHOW_MENU_LAYERS_FILTERS(state, show) {
            state.showMenuLayersFilters = show;
        },

        /****** Remote Feedback + Measure ******/
        REMOTE_TO_MEASUREMENT(state, data) {
            state.remoteToMeasurement = data;
        },

        REMOTE_TO_FEEDBACK(state, data) {
            state.remoteToFeedback = data;
        },

        SHOW_SMALL_DEVICE_MENU(state, data) {
            state.showSmallDeviceMenu = data;
        },

        NO_BASELAYER_FORCE_RELOAD(state, data) {
            state.noBaselayerForeceReload = data;
        },

        /****** UrlConnections ******/
        SET_URL_CONNECTIONS(state, data) {
            state.urlConnections = data;
        }
    },

    actions: {
        ...applicationStore.actions,
        ...msalStore.actions,
        ...printStore.actions,
        ...brkStore.actions,
        ...dashboardStore.actions,
        ...usage.actions,
        mapInitialize({ commit }, data) {
            commit('MAP_INITIALIZE', data);
        },

        setMobileUserData({ commit }, data) {
            commit('MOBILEUSER_DATA', data);
        },

        addAvailableLayers({ commit }, data) {
            commit('ADD_AVAILABLE_LAYERS', data);
        },

        removeAvailableLayers(context, data) {
            const index = context.state.availableLayers.findIndex(l => l.id === data.id);
            if (index !== -1) {
                context.commit('REMOVE_AVAILABLE_LAYERS', index);
            }
        },

        toggleSidebarLegend({ commit }, show) {
            commit('SIDEBAR_LEGEND', show);
            if (show === true) {
                commit('MOBILE_FILTERTAB', !show);
                commit('MOBILE_MENU', !show);
                commit('LAYERS_PANEL', !show);
                commit('INFORMATION_DETAIL_SIDEBAR', { display: !show });
            }
        },
        /****** Information Tab ******/
        toggleInformationOverviewTab(context, value) {
            context.commit('INFORMATION_OVERVIEW_TAB', value);
        },

        toggleInformationDetailSidebar({ commit }, data) {
            commit('INFORMATION_DETAIL_SIDEBAR', data);
            if (data.display && data.display === true) {
                commit('SIDEBAR_LEGEND', !data.display);
                commit('MOBILE_FILTERTAB', !data.display);
                commit('LAYERS_PANEL', !data.display);
                commit('MOBILE_MENU', !data.display);
            }
        },

        setInformationDataLoadingCompleted({ commit }, value) {
            commit('INFORMATION_DATA_LOADING_COMPLETED', value);
        },

        setInformationDataLoadingStarted({ commit }, value) {
            commit('INFORMATION_DATA_LOADING_STARTED', value);
        },

        setInformationTableRefreshareaUpdatebuttondisplay({ commit }, value) {
            commit('INFORMATION_TABLE_REFRESHAREA_UPDATEBUTTONDISPLAY', value);
        },

        toggleImageViewer({ commit }, data) {
            commit('IMAGE_VIEWER', data);
        },

        toggleFeedbackSidebar({ commit }, show) {
            commit('FEEDBACK_SIDEBAR', show);
        },

        toggleFeatureSelected({ commit }, feature) {
            commit('FEATURE_SELECTED', feature);
        },

        setIsMobileState({ commit }, value) {
            commit('ISMOBILE_STATE', value);
        },

        setIsIeState({ commit }, value) {
            commit('ISIE_STATE', value);
        },

        setFullScreenState({ commit }, value) {
            commit('ISFULLSCREEN_STATE', value);
        },

        setHasOfflineRequests({ commit }, value) {
            commit('HASOFFLINEREQUESTS_STATE', value);
        },

        setHasFilters({ commit }, value) {
            commit('HASFILTERS_STATE', value);
        },

        undoFilters({ commit }, value) {
            commit('UNDO_FILTERS', value);
        },

        setFeedbackData({ commit }, data) {
            commit('FEEDBACK_DATA_MUTATION', data);
        },

        setFeedbackLocationType({ commit }, data) {
            commit('FEEDBACK_LOCATION_TYPE_MUTATION', data);
        },

        setFeedbackGroups({ commit }, data) {
            commit('FEEDBACK_GROUPS_MUTATION', data);
        },

        setMapLayersLoaded({ commit }, value) {
            commit('MAPLAYERS_LOADED', value);
        },

        setStopTracking({ commit }, value) {
            commit('STOP_TRACKING', value);
        },

        setThemeLayersFeatures({ commit }, data) {
            commit('THEMELAYERS_FEATURES', data);
        },

        setContextMenu({ commit }, data) {
            commit('CONTEXT_MENU', data);
        },

        setWebFeedbackInformation({ commit }, data) {
            commit('WEBFEEDBACK_INFORMATION_MUTATION', data);
        },

        addAttributeFilters({ commit }, data) {
            commit('FILTERS_ATTRIBUTE_ADD', data);
        },
        addPersonalFilter({ commit }, data) {
            commit('FILTER_PERSONAL_ADD', data);
        },

        /****** Feedback state ******/
        setStateEditingFeedback({ commit }, data) {
            commit('STATE_EDITING_FEEDBACK', data);
        },
        setStateDigiFeedback({ commit }, data) {
            commit('STATE_DIGI_FEEDBACK', data);
        },

        /****** Feedback ******/
        setFeedbackLoadOrRefresh({ commit }, data) {
            commit('FEEDBACK_LOAD_OR_REFRESH', data);
        },

        setFeedbackEdit({ commit }, data) {
            commit('FEEDBACK_EDIT', data);
        },

        setFeedbackDelete({ commit }, data) {
            commit('FEEDBACK_DELETE', data);
        },

        setWebFeedbackLocation({ commit }, data) {
            commit('WEBFEEDBACK_LOCATION_MUTATION', data);
        },

        setWebFeedbackPanelsClose({ commit }, value) {
            commit('WEBFEEDBACK_PANELS_CLOSE', value);
        },

        setWebFeedbackFeatures({ commit }, data) {
            commit('WEBFEEDBACK_FEATURES_MUTATION', data);
        },

        setWebfeedbackCanCreate({ commit }, value) {
            commit('WEBFEEDBACK_CAN_CREATE', value);
        },

        setWebfeedbackAlertClosed({ commit }, data) {
            commit('WEBFEEDBACK_ALERT_CLOSED', data);
        },

        /****** Mobile/Web loaded themes ******/
        addLoadedTheme({ commit }, data) {
            commit('LOADED_THEMES_ADD', data);
        },

        updateLoadedTheme(context, data) {
            const index = context.state.loadedThemes.findIndex(t => t.id === data.id);
            if (index !== -1) {
                context.commit('LOADED_THEMES_UPDATE', { index, data });
            }
        },

        removedTheme({ commit }, data) {
            commit('REMOVED_THEME', data);
        },

        setLoadThemeOptions({ commit }, data) {
            commit('LOAD_THEME_OPTIONS', data);
        },

        setLoadTheme({ commit }, data) {
            commit('LOAD_THEME', data);
        },

        /****** Mobile/Web loaded feedbacks ******/
        addLoadedFeedback({ commit }, data) {
            commit('LOADED_FEEDBACKS_ADD', data);
        },

        updateLoadedFeedback(context, data) {
            const index = context.state.loadedFeedbacks.findIndex(t => t.id === data.id);
            if (index !== -1) {
                context.commit('LOADED_FEEDBACKS_UPDATE', { index, data });
            }
        },

        removedFeedback({ commit }, data) {
            commit('REMOVED_FEEDBACK', data);
        },

        /****** Mobile/Web global ******/
        setCalculatedDPI({ commit }, data) {
            commit('CALCULATED_DPI', data);
        },

        /****** Map events ******/
        setMapMoveEnd({ commit }, value) {
            commit('MAP_MOVEEND', value);
        },

        setMapClicked({ commit }, value) {
            commit('MAP_CLICKED', value);
        },

        setMapDoubleClicked({ commit }, value) {
            commit('MAP_DOUBLE_CLICKED', value);
        },

        setMapMoved({ commit }, show) {
            commit('MAP_MOVED', show);
        },

        setMapZoomed({ commit }, show) {
            commit('MAP_ZOOMED', show);
        },
        /****** Tabhold ******/
        setShowTabhold({ commit }, show) {
            commit('SHOW_TABHOLD', show);
        },

        setTabholdEndInteraction({ commit }, value) {
            commit('TABHOLD_END_INTERACTION', value);
        },

        setSelectionClear({ commit }, show) {
            commit('SELECTION_CLEAR', show);
        },

        setClearTabholdSelection({ commit }, data) {
            commit('CLEAR_TABHOLD_SELECTION', data);
        },
        /****** Information table ******/
        setLoadMoreFeatures({ commit }, data) {
            commit('LOAD_MORE_FEATURES', data);
        },
        /****** Information table refresharea ******/
        setInformationTableRefresh({ commit }, data) {
            commit('INFORMATION_TABLE_REFRESH', data);
        },
        setInformationTableUpdatebuttondisplay({ commit }, value) {
            commit('INFORMATION_TABLE_UPDATE_BUTTON_DISPLAY', value);
        },
        setInformationTableDisplayRefreshArea({ commit }, value) {
            commit('INFORMATION_TABLE_DISPLAY_REFRESHAREA', value);
        },
        setInformationTableInactiveRefreshArea({ commit }, value) {
            commit('INFORMATION_TABLE_INACTIVE_REFRESHAREA', value);
        },
        /*Webtheme*/
        setWebtheme({ commit }, data) {
            commit('WEB_THEME', data);
        },
        /****** Alerts ******/
        showAlert({ commit }, data) {
            commit('ALERT_SHOW', data);
        },

        hideAlert({ commit }, value) {
            commit('ALERT_HIDE', value);
        },

        tempHideAlert({ commit }, value) {
            commit('ALERT_HIDE_TEMP', value);
        },

        /* Gps position */
        setGpsPosition({ commit }, value) {
            commit('GPS_POSITION', value);
        },

        changeGpsIcon({ commit }, value) {
            commit('CHANGE_GPS_ICON', value);
        },

        /****** Feedback ******/
        setAlllFeedbacks({ commit }, data) {
            commit('ALL_FEEDBACKS', data);
        },

        setShowFeedbacksDialog({ commit }, data) {
            commit('SHOW_FEEDBACKS_DIALOG', data);
        },

        closeFeedbackModus({ commit }) {
            commit('CLOSE_FEEDBACK_MODUS');
        },

        showPopup({ commit }, data) {
            commit('POPUP_SHOW', data);
        },

        showFeedbackPanel({ commit }, value) {
            commit('SHOW_FEEDBACK_PANEL', value);
        },

        finishFeedback({ commit }) {
            commit('FINISH_FEEDBACK');
        },

        openFeedback({ commit }, data) {
            commit('OPEN_FEEDBACK', data);
        },

        /* Feedback digitize */
        resetDigitize({ commit }, data) {
            commit('RESET_DIGITIZE', data);
        },

        abortDigitize({ commit }, value) {
            commit('ABORT_DIGITIZE', value);
        },

        updateFeedbackGeometryType({ commit }, data) {
            commit('UPDATE_FEEDBACK_GEOMETRY_TYPE', data);
        },

        undoLastPoint({ commit }, value) {
            commit('UNDO_LAST_POINT', value);
        },

        removeFeaturesAndInteractions({ commit }, value) {
            commit('REMOVE_FEATURES_AND_INTERACTIONS', value);
        },

        updateNumPoints({ commit }, value) {
            commit('UPDATE_NUM_POINTS', value);
        },

        /****** Clusters ******/
        addCluster({ commit }, data) {
            commit('CLUSTER_ADD', data);
        },

        removeCluster({ commit }, data) {
            commit('CLUSTER_DELETE', data);
        },

        /****** RefCodes ******/
        setRefCodes({ commit }, data) {
            commit('SET_REFCODES', data);
        },

        /****** Map search ******/
        clearSearchMarkerLayer({ commit, dispatch }, value) {
            dispatch('clearParcelHighlight');
            commit('CLEAR_SEARCH_MARKER_LAYER', value);
        },

        addSearchMarkerLayer({ commit }, value) {
            commit('ADD_SEARCH_MARKER_LAYER', value);
        },

        setAddressPoint({ commit }, value) {
            commit('SET_ADDRESS_POINT', value);
        },

        /****** Mobile menu ******/
        toggleMobileMenu({ commit }, value) {
            commit('MOBILE_MENU', value);
            if (value === true) {
                commit('MOBILE_FILTERTAB', !value);
                commit('SIDEBAR_LEGEND', !value);
                commit('LAYERS_PANEL', !value);
                commit('INFORMATION_DETAIL_SIDEBAR', { display: !value });
            }
        },

        toggleMobileFilterTab({ commit }, value) {
            commit('MOBILE_FILTERTAB', value);
            if (value === true) {
                commit('MOBILE_MENU', !value);
                commit('SIDEBAR_LEGEND', !value);
                commit('LAYERS_PANEL', !value);
                commit('INFORMATION_DETAIL_SIDEBAR', { display: !value });
            }
        },

        toggleLayersPanelShow({ commit }, value) {
            commit('LAYERS_PANEL', value);
            if (value === true) {
                commit('MOBILE_MENU', !value);
                commit('SIDEBAR_LEGEND', !value);
                commit('MOBILE_FILTERTAB', !value);
                commit('INFORMATION_DETAIL_SIDEBAR', { display: !value });
            }
        },

        /****** Feedback + Measure menu in toolbar ******/
        setMeasureMenu({ commit }, value) {
            commit('SET_MEASURE_MENU', value);
        },

        setFeedbackMenu({ commit }, data) {
            commit('SET_FEEDBACK_MENU', data);
        },

        setMeasureWeb({ commit }, data) {
            commit('SET_MEASURE_WEB', data);
        },

        /****** Remote Feedback + Measure setters ******/
        setRemoteToMeasurement({ commit }, value) {
            commit('REMOTE_TO_MEASUREMENT', value);
        },

        setRemoteToFeedback({ commit }, data) {
            commit('REMOTE_TO_FEEDBACK', data);
        },

        setShowSmallDeviceMenu({ commit }, data) {
            commit('SHOW_SMALL_DEVICE_MENU', data);
            commit('SHOW_TABHOLD', true);
        },
        /****** Toolbar popup menu ******/
        setShowMenuLayersFilters({ commit }, show) {
            commit('SHOW_MENU_LAYERS_FILTERS', show);
        },

        /****** Mobile search ******/
        closeAllPanels({ commit }) {
            commit('LAYERS_PANEL', false);
            commit('MOBILE_MENU', false);
            commit('SIDEBAR_LEGEND', false);
            commit('MOBILE_FILTERTAB', false);
            commit('INFORMATION_DETAIL_SIDEBAR', { display: false });
        },
        /************/
        setNoBaselayerForeceReload({ commit }, data) {
            commit('NO_BASELAYER_FORCE_RELOAD', data);
        },
        /****** UrlConnections ******/
        setUrlConnections({ commit }, data) {
            commit('SET_URL_CONNECTIONS', data);
        }
    },

    getters: {
        ...applicationStore.getters,
        ...msalStore.getters,
        ...brkStore.getters,
        ...dashboardStore.getters,
        ...usage.getters,
        userInfo: state => state.userInfo,
        unknownUserName: state => state.unknownUserName,
        userIsAuthenticated: state => state.userInfo.isAuthenticated,
        userAuthentication: state => state.userAuthentication,
        mapSidebarState: state => state.isNavOpen,
        isMobile: state => state.isMobile,
        isFullScreen: state => state.isFullScreen,
        isIe: state => state.isIe,
        hasOfflineRequests: state => state.hasOfflineRequests,
        feedbackData: state => state.feedbackData,
        feedbackLocationType: state => state.feedbackLocationType,
        feedbackLoadOrRefresh: state => state.feedbackLoadOrRefresh,
        feedbackGroups: state => state.feedbackGroups,
        attributeFilters: state => state.attributeFilters,
        hasPersonalFilter: state => state.hasPersonalFilter,
        loadedThemes: state => state.loadedThemes,
        loadedFeedbacks: state => state.loadedFeedbacks,
        allFeedbacks: state => state.allFeedbacks,
        mobileUserData: state => state.mobileUserData,
        map: state => state.map,
        availableLayers: state => state.availableLayers,
        calculatedDPI: state => state.calculatedDPI,
        stateEditingFeedback: state => state.stateEditingFeedback,
        stateDigiFeedback: state => state.stateDigiFeedback,
        themeLayersFeatures: state => state.themeLayersFeatures,
        contextMenu: state => state.contextMenu,
        hasFilters: state => state.hasFilters,
        undoFilterTheme: state => state.undoFilterTheme,
        showTabhold: state => state.showTabhold,
        isAlwaysPolygon: state => state.isAlwaysPolygon,
        showMenuLayersFilters: state => state.showMenuLayersFilters,
        loadMoreFeatures: state => state.loadMoreFeatures,
        featureSelected: state => state.featureSelected,
        loadThemeOptions: state => state.loadThemeOptions,
        loadTheme: state => state.loadTheme,
        loadFeedbackOptions: state => state.loadFeedbackOptions,
        webTheme: state => state.webTheme,
        clusterLayerDict: state => state.clusterLayerDict,
        refCodes: state => state.refCodes,
        gpsPosition: state => state.gpsPosition,
        mobileFilterTabhow: state => state.mobileFilterTabhow,
        webfeedbackAlertClosed: state => state.webfeedbackAlertClosed,
        layersPanelShow: state => state.layersPanelShow,
        sidebarLegendShow: state => state.sidebarLegendShow,
        urlConnections: state => state.urlConnections,
        // Returns all themes and feedbacks marked as loaded
        allActiveLoadedThemes: state => {
            const visibleLoadedFeedbacks = state.loadedFeedbacks.filter(feedback => {
                return feedback.loaded === true;
            });
            const visibleLoadedThemes = state.loadedThemes.filter(theme => {
                return theme.loaded === true;
            });
            return visibleLoadedThemes.concat(visibleLoadedFeedbacks);
        },
        // Returns all themes and feedbacks marked as loaded in sorted order
        allActiveLoadedSortedThemes: (state, getters) => {
            // create shalow copy before sort, do not alter the allActiveLoadedThemes array
            return getters.allActiveLoadedThemes.slice().sort((e1, e2) => {
                if (e1.order < e2.order) {
                    // e1 before e2
                    return -1;
                } else if (e1.order > e2.order) {
                    // e2 before e1
                    return 1;
                }
                // no changes
                return 0;
            });
        },
        // Returns baselayers from loaded layers
        baseLayers: (state, getters) => {
            if (state.isMobile) {
                return getters.availableLayers.filter(layer => layer.baselayer === true);
            }
            if (getters.webTheme.baselayers) {
                return getters.webTheme.baselayers;
            }
            return [];
        }

    },

});

export default store;
